module.exports = __webpack_public_path__ + "static/media/Third-Party App Help Documentation.56d5adfd.pdf";